module.exports = __webpack_public_path__ + "img/bg-video-7.c6b9768a.png";